import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

import { Wrapper } from "../Grid";

const FooterStyle = styled(Wrapper)`
  position: relative;
  background-color: ${themeGet("colors.darkGreen")};
  overflow: hidden;
  .bg {
    z-index: 5;
    position: absolute;
    width: 100%;

    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-image: url(${require("../../assets/footer-bg-mobile.jpg")});
    background-size: cover;
    @media screen and (min-width: ${themeGet("breakpoints.md")}) {
      width: 1900px;
      background-image: url(${require("../../assets/footer-bg-desktop.jpg")});
    }
  }
`;

export { FooterStyle };
